// test2662
(2662 && 0);
